<template>
<div class="main">
  <div class="w-100">
    <div class="bottom-to-top" @click="bottomToTop" ref="bottomToTop" :class="bottomStyle"><i class="fas fa-sort-up"></i></div>
    <div class="fullheight-bg-gradient page-section " id="1">
      <div class="row fullheight">
        <div class="container mt-5 pl-0 pr-0">
          <div class="col-md-12 col-lg-7 col-xl-6 head-col-md-6 content-left">
            <transition enter-active-class="animated fadeInLeft delay-3" leave-active-class="animated fadeOutLeft" appear>
              <div class="VueCarousel-custom">
              <carousel :perPage="1" :loop="true" :perPageCustom="[[480, 1], [768, 1], [992, 1], [1280, 1]]" :navigationEnabled="false" :autoplayHoverPause="true" :paginationEnabled="true" :autoplayTimeout="3000" :autoplay="true">
                <slide class="black-frame">
                  <transition enter-active-class="animated fadeInLeft delay-1" leave-active-class="animated fadeOutLeft" appear>
                    <h1 class="text-white">{{ $t('home.title1') }}</h1>
                  </transition>
                  <div class="p-md-6 col-lg-12" style="text-indent: 25px;">
                  {{ $t('home.subtitle1') }}
                  </div>
                </slide>
                <slide class="black-frame">
                  <transition enter-active-class="animated fadeInLeft delay-1" leave-active-class="animated fadeOutLeft" appear>
                    <h1 class="text-white">{{ $t('home.title2') }}</h1>
                  </transition>
                  <div class="p-md-6 col-lg-12" style="text-indent: 25px;">
                  {{ $t('home.subtitle2') }}
                  </div>
                </slide>
                <slide class="black-frame">
                  <transition enter-active-class="animated fadeInLeft delay-1" leave-active-class="animated fadeOutLeft" appear>
                    <h1 class="text-white">{{ $t('home.title3') }}</h1>
                  </transition>
                  <div class="p-md-6 col-lg-12" style="text-indent: 25px;">
                  {{ $t('home.subtitle3') }}
                  </div>
                </slide>
                <slide class="black-frame">
                  <transition enter-active-class="animated fadeInLeft delay-1" leave-active-class="animated fadeOutLeft" appear>
                    <h1 class="text-white text-shadow">{{ $t('home.title4') }}</h1>
                  </transition>
                  <div class="p-md-6 col-lg-12" style="text-indent: 25px;">
                  {{ $t('home.subtitle4') }}
                  </div>
                </slide>
              </carousel>
              </div>
            </transition>
            <transition enter-active-class="animated fadeInDown delay-8" leave-active-class="animated fadeOutDown" appear>
              <button class="mt-3 btn btn-gradient-lg btn-lg" @click="smoothScroll, toggle = true">{{ $t('button.talkus') }}</button>
            </transition>
            <p class="p-md-6 mt-5 mb-5">
              <transition enter-active-class="animated zoomIn delay-11" leave-active-class="animated zoomOutLeft" appear>
                <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 btn btn-transparent-white pl-0 pr-0"><div class="d-flex align-items-center justify-content-centerz"><span><i class="fas fa-tools"></i></span><span><h5>B2B Tailor-Made</h5><h6>{{ $t('home.btntitle1') }}</h6></span></div></div>
              </transition>
              <transition enter-active-class="animated zoomIn delay-13" leave-active-class="animated zoomOutLeft" appear>
                <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 btn btn-transparent-white pl-0 pr-0"><div class="d-flex align-items-center justify-content-centerz"><span><i class="fas fa-chart-bar"></i></span><span><h5>B2C Package</h5><h6>{{ $t('home.btntitle2') }}</h6></span></div></div>
              </transition>
              <transition enter-active-class="animated zoomIn delay-15" leave-active-class="animated zoomOutLeft" appear>
                <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 btn btn-transparent-white pl-0 pr-0"><div class="d-flex align-items-center justify-content-centerz"><span><i class="fas fa-sitemap"></i></span><span><h5>B2B Package</h5><h6>{{ $t('home.btntitle3') }}</h6></span></div></div>
              </transition>
              <transition enter-active-class="animated zoomIn delay-17" leave-active-class="animated zoomOutLeft" appear>
                <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4 btn btn-transparent-white pl-0 pr-0"><div class="d-flex align-items-center justify-content-centerz"><span><i class="fas fa-headset"></i></span><span><h5>IT Service</h5><h6>{{ $t('home.btntitle4') }}</h6></span></div></div>
              </transition>
            </p>
          </div>
        </div>
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" appear>
          <div class="curve-bg delay-2">
            <img src="@/assets/background/curve_1.png" width="100%">
          </div>
        </transition>
      </div>
    </div>

    <div class="container page-section" id="2" ref="fadeContent1">
      <div class="row row-mt-5 halfheight halfheight-column-reverse">
      <div class="col-lg-6 md-row-mt-5 p-md-6-left">
        <div class="row">
            <div class="col-12 opacity-0 z-index-1 bg-shadow"  :class="contentStyle1">
              <img src="~@/assets/images/couple2.png" width="100%">
            </div>
            <transition enter-active-class="animated zoomIn" leave-active-class="animated zoomOut" appear>
              <div class="col-12 delay-6 col-sm-10 col-md-9 col-lg-11 col-xl-11 d-flex position-absolute blue-bg bg-left-1">
                <img src="@/assets/background/hexagon_1.png" width="100%">
              </div>
            </transition>
        </div>
      </div>
      <div class="col-lg-6 p-md-6-right ">
        <h2 class="text-blue">{{ $t('about.title') }}</h2>
        <div class="p-md-6" v-html="$t('about.content')"/>
      </div>
      </div>
    </div>

    <div class="bg-black page-section" id="3" ref="fadeContent2">
      <div class="container">
        <div class="row row-mt-5 d-flex halfheight-row-reverse halfheight halfheight-column-reverse">
          <div class="col-lg-6 md-row-mt-5 p-md-6-right">
            <div class="row">
              <div class="col-12 opacity-0 z-index-1 bg-shadow" :class="contentStyle2">
                <img src="~@/assets/images/couple1.png" width="100%">
              </div>
              <div class="col-12 col-sm-10 col-md-9 col-lg-11 col-xl-11 d-flex position-absolute blue-bg bg-right-1">
                <img src="@/assets/background/hexagon_1.png" width="100%" class="delay-4" :class="hexagonStyle1">
              </div>
            </div>
          </div>
          <div class="col-lg-6 p-md-6-left ">
            <h2 class="text-blue">{{ $t('intro.title') }}</h2>
            <div class="p-md-6">
              <b>{{ $t('intro.ul1') }}</b><br/>
              <b>{{ $t('intro.ul3') }}</b>
              <ul v-html="$t('intro.li')">
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-gradient page-section" id="4" ref="fadeContent3">
      <div class="container">
        <div class="row row-mt-5 halfheight halfheight-column-reverse">
          <div class="col-lg-6 md-row-mt-5 p-md-6-left" >
            <div class="row">
              <div class="col-12 opacity-0 img-wrap z-index-1" :class="contentStyle3">
                  <div class="img">
                    <img class="imgHover" src="~@/assets/images/mobile_laptop.png" width="100%" id="object2"  @mousemove="handleMove" @mouseleave="handleReset5">
                  </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 p-md-6-right ">
            <h2 class="text-white">{{ $t('package.title') }}</h2>
            <div class="p-md-6">
              <div v-html="$t('package.content1')"></div>
              <div class="VueCarousel-custom" style="padding: 0 !Important;">
                <carousel :perPage="1" :autoplay="true" :loop="true" :perPageCustom="[[480, 1], [768, 1], [992, 1], [1280, 1]]" :navigationEnabled="false" :autoplayHoverPause="true" :paginationEnabled="true" :autoplayTimeout="3000">
                  <slide>
                    <div class="mt-3" v-html="$t('package.content2')"></div>
                  </slide>
                  <slide>
                    <div class="mt-3" v-html="$t('package.content3')"></div>
                  </slide>
                  <slide>
                    <div class="mt-3" v-html="$t('package.content4')"></div>
                  </slide>
                </carousel>
              </div>
            </div>
            <p class="mt-3">
              <a href="https://bione.newitcorp.com" target="_blank" class="btn btn-gradient btn-d mr-2">{{ $t('button.learnmore') }}</a>
            </p>
            <div class="row mt-5 package-slide">
              <div class="col-12 col-sm-10 col-md-8 col-lg-8 col-xl-8" >
                <div class="col-12 pl-0 pr-0">
                  <vue-plyr class="plyr__video-embed delay-4" :class="videoStyle4">
                    <div class="video " data-plyr-provider="vimeo" data-plyr-embed-id="358904840"></div>
                  </vue-plyr>
                </div>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-12" >
                <div class="row d-flex align-items-center justify-content-center">
                    <div class="col-4 col-sm-4 col-md-4 col-lg-2 col-xl-2 md-row-mt-3 delay-4 partners-logo" :class="contentStyle9"><img src="~@/assets/images/logo1.png" width="100%"></div>
                    <div class="col-4 col-sm-4 col-md-4 col-lg-2 col-xl-2 md-row-mt-3 delay-5 partners-logo" :class="contentStyle9"><img src="~@/assets/images/logo2.png" width="100%"></div>
                    <div class="col-4 col-sm-4 col-md-4 col-lg-2 col-xl-2 md-row-mt-3 delay-6 partners-logo" :class="contentStyle9"><img src="~@/assets/images/logo3.png" width="100%"></div>
                    <div class="col-4 col-sm-4 col-md-4 col-lg-2 col-xl-2 md-row-mt-3 delay-7 partners-logo" :class="contentStyle9"><img src="~@/assets/images/logo4.png" width="100%"></div>
                    <div class="col-4 col-sm-4 col-md-4 col-lg-2 col-xl-2 md-row-mt-3 delay-8 partners-logo" :class="contentStyle9"><img src="~@/assets/images/logo5.png" width="100%"></div>
                    <div class="col-4 col-sm-4 col-md-4 col-lg-2 col-xl-2 md-row-mt-3 delay-9 partners-logo" :class="contentStyle9"><img src="~@/assets/images/logo6.png" width="100%"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container" ref="fadeContent4">
      <div class="row row-mt-5 d-flex halfheight-row-reverse halfheight halfheight-column-reverse">
        <div class="col-lg-6 md-row-mt-5 p-md-6-right d-none d-sm-block">
          <div class="row d-flex justify-content-center">
            <div class="col-10 col-sm-4 col-md-4 col-lg-4 mt-8 m-box opacity-0 d-none d-sm-block"  :class="contentStyle4">
              <div class="img-wrap">
                <a href="https://play.google.com/store/apps/details?id=com.newit.people" target="_blank" class="img">
                    <img class="imgHover" src="~@/assets/images/screen_iphone1.png" width="100%">
                </a>
              </div>
            </div>
            <div class="col-10 col-sm-4 col-md-4 col-lg-4 mb-10 m-box opacity-0 delay-1 d-none d-sm-block" :class="contentStyle5">
              <div class="img-wrap">
                <a href="https://play.google.com/store/apps/details?id=com.newit.pretty" target="_blank" class="img">
                    <img class="imgHover" src="~@/assets/images/screen_iphone2.png" width="100%">
                </a>
              </div>
            </div>
            <div class="col-10 col-sm-4 col-md-4 col-lg-4 mt-10 m-box opacity-0 delay-2 d-none d-sm-block" :class="contentStyle6">
              <div class="img-wrap ">
                <a href="https://play.google.com/store/apps/details?id=com.newit.tutor" target="_blank" class="img">
                    <img class="imgHover" src="~@/assets/images/screen_iphone3.png" width="100%">
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-6 p-md-6-left ">
          <h2 class="text-blue">{{ $t('package2.title') }}</h2>
          <div class="p-md-6">
            <div v-html="$t('package2.content') "></div>
          </div>
          <!-- <p class="p-md-6">
            <button class="btn btn-gradient  mr-2"><span class="icon"><i class="fab fa-android"></i></span>{{ $t('button.download') }}</button>
            <button class="btn btn-custom  mr-2"><span class="icon"><i class="fab fa-apple"></i></span>{{ $t('button.download') }}</button>
          </p> -->
          <div class="row mt-5 package-slide">
            <div class="col-12 col-sm-10 col-md-8 col-lg-8 col-xl-8" >
              <div class="col-12 pl-0 pr-0">
                <img src="~@/assets/image14.png" width="100%" :class="contentStyle10">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bg-gradient-image-1 has-blue" ref="appContent1">
      <div class="container">
        <div class="row row-mt-5 d-flex halfheight halfheight-column-reverse " style="align-items: center !important;">
          <div class="col-lg-6 md-row-mt-5 p-md-6-left">
            <div class="row d-flex justify-content-center">
              <div class="col-10 col-sm-6 col-md-6 col-lg-8 pl-5 pr-5 z-index-1" :class="appStyle1">
                <div class="img-wrap">
                  <div class="img ">
                      <img class="imgHover " src="~@/assets/images/iphone1.png" width="100%" @mouseover="hoverButton" @mouseout="hoverButton" id="mobile1" @mousemove="handleMoveMobile" @mouseleave="handleReset1">
                  </div>
                </div>
                <transition enter-active-class="animated bounceIn" leave-active-class="animated bounceOut" mode="out-in">
                  <button class="btn btn-custom-white position-absolute " style="top:-40px; right: -20px;" :class="hoverBtn" v-if="hoverBtn">
                    <h5>{{ $t('packagedetail.title1') }}</h5>
                    <h6 v-html="$t('packagedetail.content1')"></h6>
                    <h5 class="mt-2 text-nowrap" style="font-size: 0.85rem !important;"><span class="icon"><i class="fa fa-user"></i></span>{{ $t('packagedetail.detail1') }}</h5>
                  </button>
                </transition>
              </div>
              <div class="col-12 col-sm-10 col-md-9 col-lg-11 col-xl-11 d-flex position-absolute blue-bg bg-left-2">
                <img src="@/assets/background/hexagon_1.png" width="100%" class="delay-4" :class="hexagonStyle2">
              </div>
            </div>
          </div>
          <div class="col-lg-6 p-md-6-right">
            <div class="black-frame">
              <h2 class="text-white">Nearby Jobs</h2>
              <div class="p-md-6">
                <div v-html="$t('package2.app1') "></div>
              </div>
            </div>
            <p class="p-md-6">
              <a href="https://play.google.com/store/apps/details?id=com.newit.people" target="_blank" class="btn btn-gradient  mr-2"><span class="icon"><i class="fab fa-android"></i></span>{{ $t('button.download') }}</a>
            </p>
            <div class="row mt-5 package-slide">
              <div class="col-12 col-sm-10 col-md-8 col-lg-8 col-xl-8" >
                <div class="col-12 pl-0 pr-0">
                  <vue-plyr class="plyr__video-embed delay-4" :class="videoStyle1">
                    <div class="video" data-plyr-provider="vimeo" data-plyr-embed-id="358623855"></div>
                  </vue-plyr>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="curve-bg-right">
        <img src="@/assets/background/curve_2.png" width="100%">
      </div>
    </div>

    <div class="bg-gradient-image-2 has-black" ref="appContent2">
      <div class="container">
        <div class="row halfheight-row-reverse row-mt-5 d-flex halfheight halfheight-column-reverse " style="align-items: center !important; z-index: 3 !important;">
          <div class="col-lg-6 md-row-mt-5 p-md-6-right">
            <div class="row d-flex justify-content-center">
              <div class="col-10 col-sm-6 col-md-6 col-lg-8 pl-5 pr-5" :class="appStyle2">
                <transition enter-active-class="animated bounceIn" leave-active-class="animated bounceOut" mode="out-in">
                  <button class="btn btn-custom-white position-absolute" style="top:-40px; right: -20px" :class="hoverBtn1" v-if="hoverBtn1">
                    <h5>{{ $t('packagedetail.title2') }}</h5>
                    <h6 v-html="$t('packagedetail.content2')"></h6>
                    <h5 class="mt-2 text-nowrap" style="font-size: 0.85rem !important;"><span class="icon"><i class="fa fa-user"></i></span>{{ $t('packagedetail.detail2') }}</h5>
                  </button>
                </transition>
                <div class="img-wrap">
                  <div class="img ">
                      <img class="imgHover " src="~@/assets/images/iphone2.png" width="100%" @mouseover="hoverButton1" @mouseout="hoverButton1" id="mobile2" @mousemove="handleMoveMobile2" @mouseleave="handleReset2">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 p-md-6-left z-index-1">
            <h2 class="text-white">Nearby Pretty</h2>
            <div class="p-md-6">
              <div v-html="$t('package2.app2') "></div>
            </div>
            <p class="p-md-6">
              <a href="https://play.google.com/store/apps/details?id=com.newit.pretty" target="_blank" class="btn btn-custom  mr-2"><span class="icon"><i class="fab fa-android"></i></span>{{ $t('button.download') }}</a>
            </p>
            <div class="row mt-5 package-slide">
              <div class="col-12 col-sm-10 col-md-8 col-lg-8 col-xl-8" >
                <div class="col-12 pl-0 pr-0">
                  <vue-plyr class="plyr__video-embed delay-4" :class="videoStyle2">
                    <div class="video" data-plyr-provider="vimeo" data-plyr-embed-id="358624150"></div>
                  </vue-plyr>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-gradient-image-3 has-blue" ref="appContent3">
      <div class="container">
        <div class="row row-mt-5 d-flex halfheight halfheight-column-reverse " style="align-items: center !important;">
          <div class="col-lg-6 md-row-mt-5 p-md-6-left">
            <div class="row d-flex justify-content-center">
              <div class="col-10 col-sm-6 col-md-6 col-lg-8 pl-5 pr-5 z-index-1" :class="appStyle3">
                <div class="img-wrap">
                  <div class="img ">
                      <img class="imgHover " src="~@/assets/images/iphone3.png" width="100%" @mouseover="hoverButton2" @mouseout="hoverButton2" id="mobile3" @mousemove="handleMoveMobile3" @mouseleave="handleReset3">
                  </div>
                </div>
                <transition enter-active-class="animated bounceIn" leave-active-class="animated bounceOut" mode="out-in">
                  <button class="btn btn-custom-white position-absolute" style="top:-40px; left: -20px" :class="hoverBtn2" v-if="hoverBtn2">
                    <h5>{{ $t('packagedetail.title3') }}</h5>
                    <h6 v-html="$t('packagedetail.content3')"></h6>
                    <h5 class="mt-2 text-nowrap" style="font-size: 0.85rem !important;"><span class="icon"><i class="fa fa-user"></i></span>{{ $t('packagedetail.detail3') }}</h5>
                  </button>
                </transition>
              </div>
            </div>
          </div>
          <div class="col-lg-6 p-md-6-right">
            <div class="z-index-1">
              <div class="black-frame">
              <h2 class="text-white">Nearby Tutor</h2>
              <div class="p-md-6">
                <div v-html="$t('package2.app3') "></div>
              </div>
              </div>
              <p class="p-md-6">
                <a href="https://play.google.com/store/apps/details?id=com.newit.tutor" target="_blank" class="btn btn-gradient  mr-2"><span class="icon"><i class="fab fa-android"></i></span>{{ $t('button.download') }}</a>
              </p>
              <div class="row mt-5 package-slide">
                <div class="col-12 col-sm-10 col-md-8 col-lg-8 col-xl-8" >
                  <div class="col-12 pl-0 pr-0">
                    <vue-plyr class="plyr__video-embed delay-4" :class="videoStyle3">
                      <div class="video" data-plyr-provider="vimeo" data-plyr-embed-id="358624301"></div>
                    </vue-plyr>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-sm-10 col-md-9 col-lg-11 col-xl-11 d-flex position-absolute blue-bg bg-right-2">
                <img src="@/assets/background/hexagon_1.png" width="100%" class="delay-4" :class="hexagonStyle3">
            </div>
          </div>
        </div>
      </div>
      <div class="curve-bg-right">
        <img src="@/assets/background/curve_2.png" width="100%">
      </div>
    </div>

    <div class="container page-section" id="5">
      <div class="row row-mt-5 halfheight row-card">
        <div class="col-lg-12 text-center mb-3">
          <h2 class="text-blue">{{ $t('projects.title') }}</h2>
          <div class="p-md-6 text-center col-lg-5 col-xl-5 ml-auto mr-auto">
            {{ $t('projects.content') }}
          </div>
          <p class="p-md-6">
            <button class="btn btn-custom" @click="smoothScroll">{{ $t('button.contact') }}</button>
          </p>
        </div>
        <div class="col-lg-12 p-md-6 text-center mt-3 mb-3">
          <h5 style="font-weight: 600 !important; font-size: 1.35rem;">{{ $t('projects.example') }}</h5>
          <hr style="border-bottom: 3px solid #005BEA; width: 7.5%;" />
        </div>
          <div class="col-lg-12 p-md-6 mt-3">
            <div class="row">
              <carousel :perPage="1" :autoplayHoverPause="true" :paginationEnabled="false" :autoplayTimeout="3000" :autoplay="true" :navigationEnabled="true" navigationNextLabel="<i class='fas fa-chevron-right'></i>" navigationPrevLabel="<i class='fas fa-chevron-left'></i>" :loop="true" :perPageCustom="[[480, 1], [768, 2], [992, 3], [1044, 3], [1280, 4]]">
			  <slide>
                  <div class="col-md-12 col-lg-12 col-xl-12 my-card" >
                    <div class="card">
                      <img class="card-img-top" src="@/assets/image9.jpg">
                      <button class="btn btn-custom btn-sm"
                      style="width: 90px; margin: 0 !important;
                      margin-left: 20px; margin-top: -12.5px; z-index: 1;
                      padding: 0px !important; max-width: 90px;
                      overflow: hidden;text-overflow: ellipsis;">
                        <small class="text-nowrap" style="font-weight: 500; font-size: 0.5rem;">March 10 2019</small>
                      </button>
                      <div class="card-body">
                        <h5 class="card-title" style="font-size: 1rem;">{{ $t('example.title5') }}</h5>
                        <p class="card-text" style="font-size: 0.75rem;">{{ $t('example.content5') }}</p>
                        <button class="btn btn-custom-card btn-sm mt-5">{{ $t('button.readmore') }}</button>
                      </div>
                    </div>
                  </div>
              </slide>
              <slide>
                  <div class="col-md-12 col-lg-12 col-xl-12 my-card" >
                    <div class="card">
                      <img class="card-img-top" src="@/assets/image10.jpg">
                      <button class="btn btn-custom btn-sm"
                      style="width: 90px; margin: 0 !important;
                      margin-left: 20px; margin-top: -12.5px; z-index: 1;
                      padding: 0px !important; max-width: 90px;
                      overflow: hidden;text-overflow: ellipsis;">
                        <small class="text-nowrap" style="font-weight: 500; font-size: 0.5rem;">March 10 2019</small>
                      </button>
                      <div class="card-body">
                        <h5 class="card-title" style="font-size: 1rem;">{{ $t('example.title6') }}</h5>
                        <p class="card-text" style="font-size: 0.75rem;">{{ $t('example.content6') }}</p>
                        <button class="btn btn-custom-card btn-sm mt-5">{{ $t('button.readmore') }}</button>
                      </div>
                    </div>
                  </div>
              </slide>
			  <slide>
                  <div class="col-md-12 col-lg-12 col-xl-12 my-card" >
                    <div class="card">
                      <img class="card-img-top" src="@/assets/image11.jpg">
                      <button class="btn btn-custom btn-sm"
                      style="width: 90px; margin: 0 !important;
                      margin-left: 20px; margin-top: -12.5px; z-index: 1;
                      padding: 0px !important; max-width: 90px;
                      overflow: hidden;text-overflow: ellipsis;">
                        <small class="text-nowrap" style="font-weight: 500; font-size: 0.5rem;">March 10 2019</small>
                      </button>
                      <div class="card-body">
                        <h5 class="card-title" style="font-size: 1rem;">{{ $t('example.title7') }}</h5>
                        <p class="card-text" style="font-size: 0.75rem;">{{ $t('example.content7') }}</p>
                        <button class="btn btn-custom-card btn-sm mt-5">{{ $t('button.readmore') }}</button>
                      </div>
                    </div>
                  </div>
              </slide>
              </carousel>
            </div>
          </div>
      </div>
    </div>

    <div class="bg-black page-section" id="6" ref="fadeContent5">
      <div class="container">
        <div class="row row-mt-5 halfheight halfheight-column-reverse">
          <div class="col-lg-6 md-row-mt-5 p-md-6-left earth opacity-0" :class="contentStyle7">
              <img src="~@/assets/images/earth.png" width="85%">
          </div>
          <div class="col-lg-6 p-md-6-right ">
            <h2 class="text-blue">{{ $t('partners.title') }}</h2>
            <div class="p-md-6">
              <h6>{{ $t('partners.ul1') }}</h6>
              <ul v-html="$t('partners.li1')">
              </ul>
              <h6 class="p-md-bottom">{{ $t('partners.ul2') }}</h6>
              <ul v-html="$t('partners.li2')">
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="container" ref="fadeContent7">
      <div class="row halfheight row-mt-5">
        <div class="col-lg-12 text-center text-blue">
          <h2>{{ $t('customers.title') }}</h2>
        </div>
          <div class="col-lg-12 p-md-6 mt-5 customer">
            <div class="row d-flex justify-content-center align-items-center">
              <div class="col-6 col-sm-4 col-md-3 col-lg-1 col-xl-1 offset-1 delay-0" :class="contentStyle9"><img src="~@/assets/images/logo1.jpg" width="100%"></div>
              <div class="col-6 col-sm-4 col-md-3 col-lg-1 col-xl-1 offset-1 delay-1" :class="contentStyle9"><img src="~@/assets/images/logo2.jpg" width="100%"></div>
              <div class="col-6 col-sm-4 col-md-3 col-lg-1 col-xl-1 offset-1 delay-2" :class="contentStyle9"><img src="~@/assets/images/logo3.jpg" width="100%"></div>
              <div class="col-6 col-sm-4 col-md-3 col-lg-1 col-xl-1 offset-1 delay-3" :class="contentStyle9"><img src="~@/assets/images/logo4.jpg" width="100%"></div>
              <div class="col-6 col-sm-4 col-md-3 col-lg-1 col-xl-1 offset-1 delay-4" :class="contentStyle9"><img src="~@/assets/images/logo5.jpg" width="100%"></div>
              <div class="col-6 col-sm-4 col-md-3 col-lg-1 col-xl-1 offset-1 delay-5" :class="contentStyle9"><img src="~@/assets/images/logo6.jpg" width="100%"></div>
            </div>
          </div>
      </div>
    </div> -->

    <div class="bg-gradient-image-4 has-blue" id="second">
      <div class="container" ref="fadeContent6">
        <div class="row row-mt-5 d-flex halfheight halfheight-column-reverse " style="align-items: center !important;">
          <div class="col-lg-6 p-md-6-right ">
            <div class="col-12 col-sm-10 col-md-9 col-lg-11 col-xl-11 d-flex position-absolute blue-bg bg-left-3">
                <img src="@/assets/background/hexagon_1.png" width="100%" class="delay-4" :class="hexagonStyle4">
            </div>
          </div>
          <div class="col-lg-6 md-row-mt-5 p-md-6-left">
            <div class="row d-flex justify-content-center">
              <div class="col-10 col-sm-6 col-md-6 col-lg-8 pl-5 pr-5 z-index-1">
              </div>
            </div>
          </div>
          <div class="md-row-mt-5 p-md-6-left" :class="contentStyle8">
            <div class="row d-flex justify-content-center">
              <div class="col-lg-12 text-center">
                <h2>{{ $t('contact.title') }}</h2>
              </div>
              <div class="row">
                <div class="col-md-6 col-lg-3 mt-5">
                  <div class="col-lg-12 mt-5 d-flex justify-content-center">
                    <div class="hexagon hexagon-small">
                      <i class="icon fas fa-user-plus icon-1"></i>
                    </div>
                    <div class="line-icon d-none d-lg-block"></div>
                  </div>

                  <div class="col-lg-12 mt-5 text-center" style="color: #fff; padding-right: 1.25rem; padding-left: 1.25rem;">
                    <h5>{{ $t('contact.subtitle1') }}</h5>
                    <div class="mt-3">
                      {{ $t('contact.content1') }}
                    </div>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3 mt-5">
                  <div class="col-lg-12 mt-5 d-flex justify-content-center">
                    <div class="hexagon hexagon-small">
                      <i class="icon fas fa-clock icon-2"></i>
                    </div>
                    <div class="line-icon d-none d-lg-block"></div>
                  </div>

                  <div class="col-lg-12 mt-5 text-center" style="color: #fff; padding-right: 1.25rem; padding-left: 1.25rem;">
                    <h5>{{ $t('contact.subtitle2') }}</h5>
                    <div class="mt-3">
                      {{ $t('contact.content2') }}
                    </div>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3 mt-5">
                  <div class="col-lg-12 mt-5 d-flex justify-content-center">
                    <div class="hexagon hexagon-small">
                      <i class="icon fas fa-handshake icon-3"></i>
                    </div>
                    <div class="line-icon d-none d-lg-block"></div>
                  </div>

                  <div class="col-lg-12 mt-5 text-center" style="color: #fff; padding-right: 1.25rem; padding-left: 1.25rem;">
                    <h5>{{ $t('contact.subtitle3') }}</h5>
                    <div class="mt-3">
                      {{ $t('contact.content3') }}
                    </div>
                  </div>
                </div>

                <div class="col-md-6 col-lg-3 mt-5">
                  <div class="col-lg-12 mt-5 d-flex justify-content-center">
                    <div class="hexagon hexagon-small">
                      <i class="icon fas fa-thumbs-up icon-4"></i>
                    </div>
                  </div>

                  <div class="col-lg-12 mt-5 text-center" style="color: #fff; padding-right: 1.25rem; padding-left: 1.25rem;">
                    <h5>{{ $t('contact.subtitle4') }}</h5>
                    <div class="mt-3">
                      {{ $t('contact.content4') }}
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div>
  </div>
  <background/>

  <transition enter-active-class="animated bounceIn" leave-active-class="animated bounceOut" appear>
    <div class="modal-mask" v-if="toggle">
      <div class="modal-wrapper"  @click.self="toggle = false">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <div class="col-12">
                <button type="button" class="close" @click="toggle = false">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12 col-sm-6 col-md-6 col-lg-6 pl-0 pr-0 d-none d-sm-block">
                  <div>
                    <img src="@/assets/images/logo.png" width="120px">
                  </div>
                  <div class="mt-4">
                    <h5 class="title">Company</h5>
                    <p class="mt-3 subtitle">New IT Corporation</p>
                  </div>
                  <div class="mt-4">
                    <h5 class="title">Address</h5>
                    <p class="mt-3 col-8 col-lg-8 pl-0 pr-0 subtitle">99/209 Chaeng Watthana 12 Intersection 4-7-4-1 Thung Song Hong Subdistrict, Lak Si District, Bangkok</p>
                  </div>
                  <div class="mt-4">
                    <h5 class="title">Email</h5>
                    <p class="mt-3 subtitle">pongpaitoon@newitcorp.com<br/>support@newitcorp.com</p>
                  </div>
                  </div>
                  <form @submit.prevent="send" class="col-12 col-sm-6 col-md-6 col-lg-6 pl-0 pr-0">
                    <h4 class="mb-4" style="font-weight: 700 !important;">Contact Us</h4>
                    <div class="form-group input-group">
                        <div class="input-group-prepend">
                          <span class="input-group-text" id="inputGroup-sizing"><i class="fas fa-user"></i></span>
                        </div>
                      <input type="text" class="form-control" required placeholder="Name" aria-describedby="inputGroup-sizing" v-model="recipient.name">
                    </div>
                    <div class="form-group input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="inputGroup-sizing"><i class="fas fa-envelope"></i></span>
                      </div>
                      <input type="email" class="form-control" required placeholder="Email" aria-describedby="inputGroup-sizing" v-model="recipient.email">
                    </div>
                    <div class="form-group input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="inputGroup-sizing"><i class="fas fa-book"></i></span>
                      </div>
                      <input type="text" class="form-control" placeholder="Subject" aria-describedby="inputGroup-sizing" v-model="recipient.subject">
                    </div>
                    <div class="form-group input-group">
                      <div class="input-group-prepend">
                        <span class="input-group-text" id="inputGroup-sizing"><i class="fas fa-comment-dots"></i></span>
                      </div>
                      <textarea class="form-control" rows="3" placeholder="Message" aria-describedby="inputGroup-sizing" v-model="recipient.message"></textarea>
                    </div>
                    <div class="row">
                      <div class="col-12">
                        <button v-if="loading" class="btn btn-custom" type="button" disabled>
                          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                          {{ loading }}
                        </button>
                        <button v-else class="btn btn-custom">Send Message</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
  </transition>
  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" appear>
    <div class="modal-background" v-if="toggle"></div>
  </transition>
</div>
</template>

<script>
import Background from '@/components/Background'
import _ from 'lodash'
import $ from 'jquery'
import axios from 'axios'

const persons = [
  {
    name: 'Pongpaitoon Suksudej',
    photo: require('@/assets/images/avatar.png'),
    title: 'Managing Director',
    bio:
      '<p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet architecto ea blanditiis quo labore esse magnam illum ut quibusdam.</p>',
    social: {
      facebook: '#',
      twitter: 'https://twitter.com/knyttneve',
      google: '#'
    }
  },
  {
    name: 'Rachapan Sangthong',
    photo: require('@/assets/images/avatar.png'),
    title: 'Full stack Web Developer',
    bio:
      '<p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Amet architecto ea blanditiis quo labore esse magnam illum ut quibusdam.</p>',
    social: {
      facebook: '#',
      twitter: 'https://twitter.com/knyttneve',
      google: '#'
    }
  }
]

export default {
  name: 'home',
  data () {
    return {
      slides: [
        {
          url1: 'https://player.vimeo.com/video/356017722?loop=false&byline=false&portrait=false&title=false&speed=true&transparent=0&gesture=media',
          url2: 'https://player.vimeo.com/video/356023221?loop=false&byline=false&portrait=false&title=false&speed=true&transparent=0&gesture=media',
          url3: 'https://player.vimeo.com/video/356032961?loop=false&byline=false&portrait=false&title=false&speed=true&transparent=0&gesture=media'
        }
      ],
       cards: [
        
		{
          date: 'March 10 2019', title: 'บริษัท บุญศิริ โฟรเซ่น โพรดักส์', img: require('@/assets/image5.jpg'), content: 'ระบบต่อขยายงานขาย บริหารคลัง และการจัดส่ง จาก SAP ในรูปแแบบแอนดรอยด์แบบเนทีฟ เพื่อให้พนักงานสามารถใช้โทรศัพท์มือถือสั่งงานต่างๆ ไปยัง SAP ได้โดยไม่ต้องใช้ PC หรือ Notebook'
        },
		{
          date: 'March 10 2019', title: 'บริษัท ไทย-พาฝัน จำกัด', img: require('@/assets/image8.jpg'), content: 'ระบบ ERP ที่ออกแบบมาสำหรับธุรกิจโรงงาน Garment โดยเฉพาะ ให้แก่ผู้ผลิตเสื้อผ้ารายใหญ่ของ Uniqlo ควบคุมสินค้าในระดับ Serial Number เชื่อมโยงงานบัญชีกับ Navision'
        },
        {
          date: 'March 10 2019', title: 'บริษัท เทมโป-ไทย จำกัด', img: require('@/assets/image10.jpg'), content: 'แอพพลิเคชั่นแอนดรอยด์แบบเนทีฟ สำหรับการติดตามยานพาหนะที่ออกไปให้บริการลูกค้าตามบ้าน ด้วย GPS ทำให้ผู้บริหารและลูกค้ารับทราบสถานะ แบบ real time รวมถึงระบบเบิกเคมีภัณฑ์'
        }
      ],
      user: JSON.parse(localStorage.getItem('user')),
      recipient: {
        name: '',
        email: '',
        subject: '',
        message: ''
      },
      loading: '',
      status: '',
      toggle: false,
      loopActive: true,
      activeImage: false,
      hoverBtn: true,
      hoverBtn1: true,
      hoverBtn2: true,
      scrolled: false,
      persons: persons,
      selectedPersonIndex: null,
      isSelected: false,
      selectedPerson: null,
      inlineStyles: null,
      isReady: false,
      isOk: false,
      button: {
        top: 0,
        windowHeight: 0,
        windowScrollTop: 0
      },
      fade: {
        top1: 0,
        top2: 0,
        top3: 0,
        top4: 0,
        top5: 0,
        top6: 0,
        top7: 0,
        app1: 0,
        app2: 0,
        app3: 0,
        windowHeight: 0,
        windowScrollTop: 0
      },
      selectedPersonData: {
        name: null,
        title: null,
        photo: null,
        social: {
          facebook: null,
          twitter: null,
          google: null
        }
      }
    }
  },
  props: {
    loop: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Background
  },
  methods: {
    send () {
      this.loading = 'Sending...'
      const formData = new FormData()
      formData.append('recipient', JSON.stringify(this.recipient))
      axios.post('http://localhost:5000/sendmail', formData, {
        headers: { 'x-access-token': localStorage.getItem('token') }
      }).then(res => {
        this.$Progress.start()
        if (res) {
          this.$swal('Success', `${res.data.message}`, 'success')
          this.loading = ''
          this.status = res.data.message
          this.recipient.name = ''
          this.recipient.email = ''
          this.recipient.subject = ''
          this.recipient.message = ''
          this.toggle = false
        }
      })
    },
    stopLoop () {
      this.loopActive = false
    },
    smoothScroll () {
      $('html, body').animate({
        scrollTop: $('#second').offset().top
      }, 800)
    },
    handleMoveMobile (e) {
      // document.getElementById('object').style.transform = 'rotateY(' + e.clientX + 'deg)'
      var valueX = (e.pageX * -0.25 / 25)
      var valueY = (e.pageY * 0.25 / 25)
      var rotateX = (e.clientX * -0.20 / 20)
      var rotateY = (e.clientY * -0.20 / 20)
      var rotateZ = (e.clientX * 0.10 / 20)
      document.getElementById('mobile1').style.transform = 'translate3d(' + valueX + 'px, ' + valueY + 'px, 0)' + 'rotateY(' + rotateX + 'deg)' + 'rotateX(' + rotateY + 'deg)' + 'rotateZ(' + rotateZ + 'deg)'
    },
    handleMoveMobile2 (e) {
      var valueX = (e.pageX * -0.25 / 25)
      var valueY = (e.pageY * 0.25 / 25)
      var rotateX = (e.clientX * -0.20 / 20)
      var rotateY = (e.clientY * 0.20 / 20)
      var rotateZ = (e.clientX * -0.10 / 60)
      document.getElementById('mobile2').style.transform = 'translate3d(' + valueX + 'px, ' + valueY + 'px, 0)' + 'rotateY(' + rotateX + 'deg)' + 'rotateX(' + rotateY + 'deg)' + 'rotateZ(' + rotateZ + 'deg)'
    },
    handleMoveMobile3 (e) {
      var valueX = (e.pageX * -0.25 / 25)
      var valueY = (e.pageY * 0.25 / 25)
      var rotateX = (e.clientX * -0.20 / 20)
      var rotateY = (e.clientY * 0.20 / 20)
      var rotateZ = (e.clientX * 0.10 / 50)
      document.getElementById('mobile3').style.transform = 'translate3d(' + valueX + 'px, ' + valueY + 'px, 0)' + 'rotateY(' + rotateX + 'deg)' + 'rotateX(' + rotateY + 'deg)' + 'rotateZ(' + rotateZ + 'deg)'
    },
    handleReset1 (e) {
      var valueX = 0
      var valueY = 0
      var rotateX = 0
      var rotateY = 0
      var rotateZ = 0
      document.getElementById('mobile1').style.transform = 'translate3d(' + valueX + 'px, ' + valueY + 'px, 0)' + 'rotateY(' + rotateX + 'deg)' + 'rotateX(' + rotateY + 'deg)' + 'rotateZ(' + rotateZ + 'deg)'
    },
    handleReset2 (e) {
      var valueX = 0
      var valueY = 0
      var rotateX = 0
      var rotateY = 0
      var rotateZ = 0
      document.getElementById('mobile2').style.transform = 'translate3d(' + valueX + 'px, ' + valueY + 'px, 0)' + 'rotateY(' + rotateX + 'deg)' + 'rotateX(' + rotateY + 'deg)' + 'rotateZ(' + rotateZ + 'deg)'
    },
    handleReset3 (e) {
      var valueX = 0
      var valueY = 0
      var rotateX = 0
      var rotateY = 0
      var rotateZ = 0
      document.getElementById('mobile3').style.transform = 'translate3d(' + valueX + 'px, ' + valueY + 'px, 0)' + 'rotateY(' + rotateX + 'deg)' + 'rotateX(' + rotateY + 'deg)' + 'rotateZ(' + rotateZ + 'deg)'
    },
    handleReset4 (e) {
      var valueX = 0
      var valueY = 0
      var rotateX = 0
      var rotateY = 0
      var rotateZ = 0
      document.getElementById('object1').style.transform = 'translate3d(' + valueX + 'px, ' + valueY + 'px, 0)' + 'rotateY(' + rotateX + 'deg)' + 'rotateX(' + rotateY + 'deg)' + 'rotateZ(' + rotateZ + 'deg)'
    },
    handleReset5 (e) {
      var valueX = 0
      var valueY = 0
      var rotateX = 0
      var rotateY = 0
      var rotateZ = 0
      document.getElementById('object2').style.transform = 'translate3d(' + valueX + 'px, ' + valueY + 'px, 0)' + 'rotateY(' + rotateX + 'deg)' + 'rotateX(' + rotateY + 'deg)' + 'rotateZ(' + rotateZ + 'deg)'
    },
    handleAppReset1 (e) {
      var valueX = 0
      var valueY = 0
      var rotateX = 0
      var rotateY = 0
      var rotateZ = 0
      document.getElementById('app1').style.transform = 'translate3d(' + valueX + 'px, ' + valueY + 'px, 0)' + 'rotateY(' + rotateX + 'deg)' + 'rotateX(' + rotateY + 'deg)' + 'rotateZ(' + rotateZ + 'deg)'
    },
    handleMove (e) {
      var valueX = (e.pageX * -0.25 / 25)
      var valueY = (e.pageY * 0.25 / 25)
      var rotateX = (e.clientX * -0.20 / 12)
      var rotateY = (e.clientY * 0.20 / 50)
      var rotateZ = (e.clientX * -0.10 / 20)
      document.getElementById('object2').style.transform = 'translate3d(' + valueX + 'px, ' + valueY + 'px, 0)' + 'rotateY(' + rotateX + 'deg)' + 'rotateX(' + rotateY + 'deg)' + 'rotateZ(' + rotateZ + 'deg)'
    },
    handleMoveApp1 (e) {
      var valueX = (e.pageX * -0.25 / 25)
      var valueY = (e.pageY * 0.25 / 25)
      var rotateX = (e.clientX * -0.20 / 20)
      var rotateY = (e.clientY * 0.20 / 20)
      var rotateZ = (e.clientX * -0.10 / 20)
      document.getElementById('app1').style.transform = 'translate3d(' + valueX + 'px, ' + valueY + 'px, 0)' + 'rotateY(' + rotateX + 'deg)' + 'rotateX(' + rotateY + 'deg)' + 'rotateZ(' + rotateZ + 'deg)'
    },
    handleMoveApp2 (e) {
      var valueX = (e.pageX * -0.25 / 25)
      var valueY = (e.pageY * 0.25 / 25)
      var rotateX = (e.clientX * -0.20 / 12)
      var rotateY = (e.clientY * 0.20 / 50)
      var rotateZ = (e.clientX * -0.10 / 20)
      document.getElementById('app2').style.transform = 'translate3d(' + valueX + 'px, ' + valueY + 'px, 0)' + 'rotateY(' + rotateX + 'deg)' + 'rotateX(' + rotateY + 'deg)' + 'rotateZ(' + rotateZ + 'deg)'
    },
    handleMoveMain (e) {
      var valueX = (e.pageX * -0.25 / 25)
      var valueY = (e.pageY * 0.25 / 25)
      var rotateX = (e.clientX * 0.20 / 12)
      var rotateY = (e.clientY * -0.20 / 12)
      var rotateZ = (e.clientY * -0.15 / 20)
      document.getElementById('object1').style.transform = 'translate3d(' + valueX + 'px, ' + valueY + 'px, 0)' + 'rotateY(' + rotateX + 'deg)' + 'rotateX(' + rotateY + 'deg)' + 'rotateZ(' + rotateZ + 'deg)'
    },
    bottomToTop () {
      $('html, body').animate({
        scrollTop: 0
      }, 800)
      return false
    },
    hoverButton () {
      this.hoverBtn = !this.hoverBtn
    },
    hoverButton1 () {
      this.hoverBtn1 = !this.hoverBtn1
    },
    hoverButton2 () {
      this.hoverBtn2 = !this.hoverBtn2
    },
    calculateContent () {
      this.button.top = this.$refs.bottomToTop.getBoundingClientRect().top + window.scrollY
      this.fade.top1 = this.$refs.fadeContent1.getBoundingClientRect().top + window.scrollY - 50
      // this.fade.height = this.$refs.fadeContent1.offsetHeight
      this.button.windowHeight = window.innerHeight
      this.fade.windowHeight = window.innerHeight
      this.fade.top2 = this.$refs.fadeContent2.getBoundingClientRect().top + window.scrollY - 50
      this.fade.top3 = this.$refs.fadeContent3.getBoundingClientRect().top + window.scrollY - 50
      this.fade.top4 = this.$refs.fadeContent4.getBoundingClientRect().top + window.scrollY - 50
      this.fade.top4 = this.$refs.fadeContent4.getBoundingClientRect().top + window.scrollY - 50
      this.fade.top5 = this.$refs.fadeContent5.getBoundingClientRect().top + window.scrollY - 50
      this.fade.top6 = this.$refs.fadeContent6.getBoundingClientRect().top + window.scrollY - 50
      // this.fade.top7 = this.$refs.fadeContent7.getBoundingClientRect().top + window.scrollY - 50
      this.fade.app1 = this.$refs.appContent1.getBoundingClientRect().top + window.scrollY - 50
      this.fade.app2 = this.$refs.appContent2.getBoundingClientRect().top + window.scrollY - 50
      this.fade.app3 = this.$refs.appContent3.getBoundingClientRect().top + window.scrollY - 50
    },
    handleContent: _.throttle(function () {
      this.calculateContent()
    }, 100),
    handleScroll: _.throttle(function () {
      this.button.windowScrollTop = window.pageYOffset || document.documentElement.scrollTop
      this.fade.windowScrollTop = window.pageYOffset || document.documentElement.scrollTop
    }, 100),
    selectPerson (index, el) {
      if (!this.isOk) {
        document.documentElement.style.overflow = 'hidden'
        this.selectedPersonIndex = index
        this.isSelected = true
        el.target.parentElement.className === 'person-details'
          ? (this.selectedPerson = el.target.parentElement.parentElement)
          : (this.selectedPerson = el.target.parentElement)

        this.selectedPerson.classList.add('person-selected')
        this.selectedPerson.setAttribute(
          'style',
          `width:${this.selectedPerson.offsetWidth}px`
        )
        this.selectedPersonData = this.persons[index]
        // window.setTimeout(() => {
        //   this.inlineStyles = `
        //   width: ${this.selectedPerson.offsetWidth}px;
        //   height: ${this.selectedPerson.offsetHeight}px;
        //   left: ${this.selectedPerson.offsetLeft}px;
        //   top: ${this.selectedPerson.offsetTop}px;
        //   position: fixed;`
        //   this.selectedPerson.setAttribute('style', this.inlineStyles)
        // }, 400)
        window.setTimeout(() => {
          this.isReady = true
          this.isOk = true
        }, 420)
      } else {
        document.documentElement.style.overflow = 'auto'
        this.reset()
      }
    },
    reset () {
      this.isReady = false
      window.setTimeout(() => {
        this.selectedPerson.classList.add('person-back')
      }, 280)
      window.setTimeout(() => {
        this.selectedPerson.setAttribute('style', '')
      }, 340)
      window.setTimeout(() => {
        this.isSelected = false
        this.selectedPerson.classList.remove('person-back', 'person-selected')
        this.isOk = false
      }, 400)
    }
  },
  mounted () {
    this.calculateContent()
  },
  computed: {
    bottomStyle () {
      if ((this.fade.windowScrollTop + this.fade.windowHeight) >= this.fade.top2) {
        return { 'animated bounceIn': true }
      } else {
        return { 'animated bounceOut': true }
      }
    },

    contentStyle1 () {
      if ((this.fade.windowScrollTop + this.fade.windowHeight) >= this.fade.top1) {
        return { 'animated fadeInLeft': true }
      } else {
        return { 'animated fadeOutLeft': true }
      }
    },

    contentStyle2 () {
      if ((this.fade.windowScrollTop + this.fade.windowHeight) >= this.fade.top2) {
        return { 'animated fadeInRight': true }
      } else {
        return { 'animated fadeOutRight': true }
      }
    },

    contentStyle3 () {
      if ((this.fade.windowScrollTop + this.fade.windowHeight) >= this.fade.top3) {
        return { 'animated fadeInLeft': true }
      } else {
        return { 'animated fadeOutLeft': true }
      }
    },

    videoStyle4 () {
      if ((this.fade.windowScrollTop + this.fade.windowHeight) >= this.fade.top3) {
        return { 'animated fadeInRight': true }
      } else {
        return { 'animated fadeOutRight': true }
      }
    },

    contentStyle4 () {
      if ((this.fade.windowScrollTop + this.fade.windowHeight) >= this.fade.top4) {
        return { 'animated fadeInUp': true }
      } else {
        return { 'animated fadeOutUp': true }
      }
    },

    contentStyle5 () {
      if ((this.fade.windowScrollTop + this.fade.windowHeight) >= this.fade.top4) {
        return { 'animated fadeInDown': true }
      } else {
        return { 'animated fadeOutDown': true }
      }
    },

    contentStyle6 () {
      if ((this.fade.windowScrollTop + this.fade.windowHeight) >= this.fade.top4) {
        return { 'animated fadeInUp': true }
      } else {
        return { 'animated fadeOutUp': true }
      }
    },

    contentStyle7 () {
      if ((this.fade.windowScrollTop + this.fade.windowHeight) >= this.fade.top5) {
        return { 'animated fadeInLeft': true }
      } else {
        return { 'animated fadeOutLeft': true }
      }
    },

    contentStyle8 () {
      if ((this.fade.windowScrollTop + this.fade.windowHeight) >= this.fade.top6) {
        return { 'animated fadeIn': true }
      } else {
        return { 'animated fadeOut': true }
      }
    },

    contentStyle9 () {
      if ((this.fade.windowScrollTop + this.fade.windowHeight) >= this.fade.top3) {
        return { 'animated bounceIn': true }
      } else {
        return { 'animated bounceOut': true }
      }
    },

    contentStyle10 () {
      if ((this.fade.windowScrollTop + this.fade.windowHeight) >= this.fade.top4) {
        return { 'animated fadeInLeft': true }
      } else {
        return { 'animated fadeOutLeft': true }
      }
    },

    appStyle1 () {
      if ((this.fade.windowScrollTop + this.fade.windowHeight) >= this.fade.app1) {
        return { 'animated fadeInLeft': true }
      } else {
        return { 'animated fadeOutLeft': true }
      }
    },

    appStyle2 () {
      if ((this.fade.windowScrollTop + this.fade.windowHeight) >= this.fade.app2) {
        return { 'animated fadeInRight': true }
      } else {
        return { 'animated fadeOutRight': true }
      }
    },
    appStyle3 () {
      if ((this.fade.windowScrollTop + this.fade.windowHeight) >= this.fade.app3) {
        return { 'animated fadeInLeft': true }
      } else {
        return { 'animated fadeOutLeft': true }
      }
    },

    hexagonStyle1 () {
      if ((this.fade.windowScrollTop + this.fade.windowHeight) >= this.fade.top2) {
        return { 'animated zoomIn': true }
      } else {
        return { 'animated zoomOut': true }
      }
    },

    hexagonStyle2 () {
      if ((this.fade.windowScrollTop + this.fade.windowHeight) >= this.fade.app1) {
        return { 'animated zoomIn': true }
      } else {
        return { 'animated zoomOut': true }
      }
    },

    hexagonStyle3 () {
      if ((this.fade.windowScrollTop + this.fade.windowHeight) >= this.fade.app3) {
        return { 'animated zoomIn': true }
      } else {
        return { 'animated zoomOut': true }
      }
    },
    hexagonStyle4 () {
      if ((this.fade.windowScrollTop + this.fade.windowHeight) >= this.fade.top6) {
        return { 'animated zoomIn': true }
      } else {
        return { 'animated zoomOut': true }
      }
    },

    videoStyle1 () {
      if ((this.fade.windowScrollTop + this.fade.windowHeight) >= this.fade.app1) {
        return { 'animated fadeInRight': true }
      } else {
        return { 'animated fadeOutRight': true }
      }
    },

    videoStyle2 () {
      if ((this.fade.windowScrollTop + this.fade.windowHeight) >= this.fade.app2) {
        return { 'animated fadeInLeft': true }
      } else {
        return { 'animated fadeOutLeft': true }
      }
    },

    videoStyle3 () {
      if ((this.fade.windowScrollTop + this.fade.windowHeight) >= this.fade.app3) {
        return { 'animated fadeInRight': true }
      } else {
        return { 'animated fadeOutRight': true }
      }
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.handleContent)
  }
}
</script>
